import { stateMap } from '../stateMap'
// import { DownloadTemplateButton } from './DownloadTemplateButton'
import { LogItemContent } from './LogItemContent'
import Timeline from './Timeline'
import { TimeLineItem, TimelineItemContent, TimelineItemIcon } from './TimeLineItem'
import { CompletedAction } from './next-actions/CompletedAction'
import { ReviewAction } from './next-actions/ReviewAction'
import { StartAction } from './next-actions/StartAction'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconV2CommentOutline } from '@icons/IconV2CommentOutline'

type LogItem = RestSchemas['Messages.DataAssets.TDataAssetActivity']

function renderNextAction(lastActivity: LogItem) {
  switch (lastActivity.state) {
    case 'Final':
      return CompletedAction
    case 'Uploaded':
      return ReviewAction
    default:
      return StartAction
  }
}

export function ActivityLogV2Content({
  activityLog,
  lastActivity,
  // url,
  // updatedText,
  // handleDownloadTemplate,
  // isPending,
  entityId,
  dataAssetId,
}: {
  activityLog: LogItem[]
  lastActivity: LogItem
  url: string
  updatedText: string
  handleDownloadTemplate: () => void
  isPending: boolean
  entityId: number
  dataAssetId: number
}) {
  const NextAction = renderNextAction(lastActivity)
  return (
    <div className="pt-5">
      {/* {url && (
        <DownloadTemplateButton updatedText={updatedText} onClick={handleDownloadTemplate} disabled={isPending} />
      )} */}
      <Timeline>
        <>
          {activityLog
            .filter((logItem) => logItem.state !== 'Discarded')
            .map((logItem) => {
              const validState = logItem.state in stateMap ? (logItem.state as keyof typeof stateMap) : 'None'
              const isComment = logItem.activity === 'Comment'
              const Icon = isComment ? IconV2CommentOutline : stateMap[validState].icon
              return (
                <TimeLineItem key={logItem.date}>
                  <TimelineItemIcon
                    Icon={Icon}
                    variant={isComment ? 'outline' : stateMap[validState].variant}
                  />
                  <TimelineItemContent>
                    {/* TimeLine Item Here */}
                    <LogItemContent {...logItem} />
                  </TimelineItemContent>
                </TimeLineItem>
              )
            })}
          <TimeLineItem>
            <TimelineItemIcon Icon={null} />
            <TimelineItemContent>
              {/* Next Action Here */}
              <NextAction entityId={entityId} dataAssetId={dataAssetId} lastActivity={lastActivity} />
            </TimelineItemContent>
          </TimeLineItem>
        </>
      </Timeline>
    </div>
  )
}
